goog.provide("shadow.js.shim.module$$mui$icons_material$Report");
goog.provide("module$shadow_js_shim_module$$mui$icons_material$Report");
shadow.js.shim.module$$mui$icons_material$Report = shadow.js.nativeProvides["@mui/icons-material/Report"] = shadow$bridge("@mui/icons-material/Report");
module$shadow_js_shim_module$$mui$icons_material$Report.default = shadow.js.shim.module$$mui$icons_material$Report;
